import { type Reducer } from 'redux';

import { type updateFeelCheck, ACTIONS } from '@~/actions/feel-check';

export interface IFeelCheckState {
  feelCheckCompletedCount: number;
  currentFeelCheckSenseSetNumber: number;
  currentFeelCheckBodySetNumber: number;
  currentFeelCheckCompletedDate: number;
}

const initialState: IFeelCheckState = {
  feelCheckCompletedCount: 0,
  currentFeelCheckSenseSetNumber: 0,
  currentFeelCheckBodySetNumber: 0,
  currentFeelCheckCompletedDate: 0,
};

type TFeelCheckReducer = Reducer<IFeelCheckState, ReturnType<typeof updateFeelCheck>>;

const feelCheckReducer: TFeelCheckReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ACTIONS.UPDATE_FEEL_CHECK) {
    return {
      ...state,
      ...payload,
    };
  }

  return state;
};

export default feelCheckReducer;
